import { render } from "./CountryDropdown.vue?vue&type=template&id=8a4c5338&scoped=true"
import script from "./CountryDropdown.vue?vue&type=script&lang=ts"
export * from "./CountryDropdown.vue?vue&type=script&lang=ts"

import "./CountryDropdown.vue?vue&type=style&index=0&id=8a4c5338&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8a4c5338"

export default script